import React from "react";

import { TextField, makeStyles, MenuItem } from "@material-ui/core";
import { clsx } from "clsx";

const useStyles = (searchColor) =>
  makeStyles((theme) => ({
    textField: {
      fontSize: "12px !important",
      width: "100%",
      [`& fieldset`]: {
        borderRadius: theme.spacing(4),
        border: "0px",
        background: searchColor && "rgba(226, 19, 110, 0.04)",
      },

      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        background: "white",
        padding: 4,
        borderRadius: 5,
        transform: "translate(14px, -11px) scale(.9)",
        fontSize: "12px !important",
        color: searchColor && "rgba(226, 19, 110, 1)",
      },

      "& .MuiInputBase-root": {
        "& .MuiOutlinedInput-notchedOutline": {
          "& legend": {
            maxWidth: 0,
          },
        },
      },

      "& .MuiOutlinedInput-root": { borderRadius: 32 },
    },
    textFieldInput: {
      fontSize: "14px !important",
      minHeight: 20,
      marginLeft: 8,
      borderRadius: "32px !important",
      background: "white !important",
    },
    textFieldLabel: {
      textAlign: "initial",
      fontSize: "14px !important",
      margin: 0,

      fontFamily: "Inter",
    },
  }));

export default function SelectInput({
  value,
  endAdornment,
  startAdornment,
  searchColor,
  options,
  className,
  ...rest
}) {
  const classes = useStyles(searchColor)();

  return (
    <TextField
      variant="outlined"
      value={value || ""}
      margin="normal"
      fullWidth
      autoComplete="off"
      className={clsx(classes.textField, className)}
      InputLabelProps={{
        className: classes.textFieldLabel,
      }}
      InputProps={{
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        classes: {
          input: classes.textFieldInput,
        },
      }}
      {...rest}
      select
    >
      {options.map(({ label, value }, _i) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}
